<mat-card appearance="outlined" class="mb-3" [formGroup]="form">
    <div class="d-flex flex-row">
        @if (dragEnabled) {
            <div class="d-flex align-items-center px-2 border-end">
                <mat-icon class="text-muted drag-handle" cdkDragHandle>drag_indicator</mat-icon>
            </div>
        }
        <div class="flex-grow-1">
            <mat-card-content class="pt-3">
                <div class="row">
                    <div class="col-12 mb-3" [ngClass]="{ 'col-md-6': !isPersistent }">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                formControlName="name"
                                [id]="getUniqueId('dynamic-field-name-input')"
                                autocomplete="off"
                                pattern="[A-Za-z0-9_]+"
                                [imask]="nameMask"
                                [readonly]="true"
                                class="dynamic-field-name-input"
                            />
                            @if (nameCtrl.hasError('required')) {
                                <mat-error>Name is required</mat-error>
                            }
                            @if (nameCtrl.hasError('pattern')) {
                                <mat-error>Only letters, numbers, and underscores are allowed.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    @if (!isPersistent) {
                        <div class="col-12 col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="fieldType">
                                    @for (fieldType of fieldTypes; track fieldType) {
                                        <mat-option [value]="fieldType">
                                            {{ fieldType | titlecase }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    }
                    @if (showOptions) {
                        <div class="col-12 mb-3">
                            <app-dynamic-field-options-form
                                [optionsCtrl]="optionsCtrl"
                                [fieldId]="id"
                            ></app-dynamic-field-options-form>
                        </div>
                    }

                    <div class="col-12 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Validators</mat-label>
                            <mat-select
                                formControlName="selectedValidators"
                                multiple
                                [id]="getUniqueId('dynamic-field-selected-validators')"
                                class="dynamic-field-selected-validators"
                            >
                                @for (validator of dynamicFieldValidators; track validator) {
                                    <mat-option [value]="validator">
                                        {{ validator | titlecase }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    @if (hasValidationWithSettings) {
                        <div class="col-12 mb-3">
                            <div class="form-label mb-1">Validation Settings</div>
                            <div class="mx-2 mx-md-4">
                                <app-dynamic-field-validations-form
                                    [validationsCtrl]="validationsCtrl"
                                ></app-dynamic-field-validations-form>
                            </div>
                        </div>
                    }

                    <div class="col-12 col-md-6 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Label</mat-label>
                            <input matInput formControlName="label" />
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Placeholder</mat-label>
                            <input matInput formControlName="placeholder" />
                        </mat-form-field>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Hint</mat-label>
                            <input matInput formControlName="hint" />
                        </mat-form-field>
                    </div>
                    @if (showAutoPopulateAndMapping) {
                        <div class="row">
                            <div class="col-12 col-md-6 mb-1 d-flex align-items-center">
                                <mat-slide-toggle
                                    formControlName="isDynamic"
                                    [id]="getUniqueId('auto-populate-toggle')"
                                >
                                    Auto-populate
                                </mat-slide-toggle>
                            </div>
                            @if (isDynamicCtrl.value) {
                                <div class="col-12 col-md-6 mb-3">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Prefill from</mat-label>
                                        <mat-select formControlName="value" [id]="getUniqueId('prefill-from-select')">
                                            @for (option of prefillKeys; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            }
                            <div class="col-12 mb-3">
                                <p class="cargo-caption">{{ autoPopulateHint }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 mb-1 d-flex align-items-center">
                                <mat-slide-toggle
                                    formControlName="isValueMappingEnabled"
                                    [id]="getUniqueId('mapping-toggle')"
                                >
                                    Map-value
                                </mat-slide-toggle>
                            </div>
                            @if (isValueMappingEnabledCtrl?.value) {
                                <div class="col-12 col-md-6 mb-3">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Mapped Field Name</mat-label>
                                        <mat-select
                                            formControlName="mappedFieldName"
                                            [id]="getUniqueId('mapped-field-name-select')"
                                        >
                                            @for (option of mappingKeys; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            }
                            <div class="col-12 mb-3">
                                <p class="cargo-caption">{{ valueMappingHint }}</p>
                            </div>
                        </div>
                    }
                </div>
            </mat-card-content>
            @if (showDeleteButton || showDisabledToggle) {
                <div class="px-4">
                    <mat-card-footer class="px-1 pb-1">
                        <div class="d-flex justify-content-start align-items-center">
                            @if (showDisabledToggle) {
                                <div class="flex-grow-1 d-flex justify-content-start">
                                    <mat-slide-toggle formControlName="isDisabled">Disabled field</mat-slide-toggle>
                                </div>
                            }
                            @if (showDeleteButton) {
                                <button
                                    mat-icon-button
                                    type="button"
                                    color="warn"
                                    (click)="delete()"
                                    [id]="getUniqueId('delete-btn')"
                                    class="dynamic-field-form-delete"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </div>
                    </mat-card-footer>
                </div>
            }
        </div>
    </div>
</mat-card>
